import { proxy } from 'valtio';

const klimaTimebarState = proxy({
  areaActive: false,
  position: 0, // continuous 0.0 – 1.0 mapping to years 1856–2100
});

export default klimaTimebarState;
